import api from './api';

export const businessService = {
  /**
   * Exports all business data as a downloadable JSON file
   */
  exportData: async (options = {}) => {
    try {
      const exportRequest = {
        includeCustomers: options.includeCustomers !== false,
        includeJobs: options.includeJobs !== false,
        includeInvoices: options.includeInvoices !== false,
        includeLeads: options.includeLeads !== false,
        includeServiceTypes: options.includeServiceTypes !== false,
        format: options.format || 'JSON'
      };

      const response = await api.post('/business/export-data', exportRequest, {
        responseType: 'blob'
      });

      const blob = new Blob([response.data], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'suddyflow-export.json';
      
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }
      
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return blob;
    } catch (error) {
      console.error('Error exporting data:', error);
      throw error;
    }
  },

  /**
   * Gets business profile (includes lat/lng for weather)
   */
  getProfile: async () => {
    return await api.get('/business/profile');
  },
  
  /**
   * Route Settings
   */
  getRouteSettings: async () => {
    return await api.get('/business/route-settings');
  },

  updateRouteSettings: async (settings) => {
    return await api.put('/business/route-settings', settings);
  },
};

export default businessService;